import React from "react"
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper"
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage"
import "./quoteWidget.scss"

const QuoteWidget = ({ blok }) => {
//   const text = resolveRichText(blok.text)
const borderTop = blok.top_border ? "quote-border-top" : null;
const borderBottom = blok.bottom_border ? "quote-border-bottom" : null;
const borderColor = blok.border_color ? blok.border_color : null;
const textColor = blok.text_color ? blok.text_color : null;
const openQuote = '“';
const endQuote = '”' ;
let quote = blok.quote;
if(quote){
    if(quote.charAt(0) === '"'){
        quote = openQuote + quote.substring(1);
    }else if(quote.charAt(0) !== openQuote){
        quote = openQuote + quote;
    }
    if(quote.charAt(quote.length - 1) === '"'){
        quote[quote.length - 1] = endQuote;
    }else if(quote.charAt(quote.length - 1) !== endQuote){
        quote = quote + endQuote
    }
}

let quoteAuthor = blok.quote_author;
if( quoteAuthor){
    if(quoteAuthor.charAt(0) === "-"){
        quoteAuthor[0] = "– ";
    }else if(quoteAuthor.charAt(0) !== "–"){
        quoteAuthor = "– " + quoteAuthor;
    } 
    
}

  return (
    <WidgetWrapper blok={blok}>
        <div className="quote-container">
            <div className={["quote", borderTop, borderBottom, borderColor, textColor].join(" ")}>
                {(blok.image && blok.image.filename) && blok.show_img ? <div className="quote-img"><StoryblokImage sbImageData={blok.image}/></div>: null}
                {blok.quote ? <h3>{quote}</h3> : null}
                {blok.quote_author ? <p>{quoteAuthor}</p>: null}
            </div>
      </div>
    </WidgetWrapper>
  )
}

export default QuoteWidget
